import { createAction, props } from '@ngrx/store';

export const changeVisibilityOfBackendError = createAction(
  '[BackendError] Update visibility of BackendErrorPopup',
  props<{
    showBackendErrorPopup: boolean;
  }>(),
);

export const setVisibilityOfCustomerChat = createAction(
  '[Chat] Set visibility of Genesys chat',
  props<{
    showCustomerChat: boolean;
  }>(),
);
